import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// template-instantiated child widget (data-dojo-type) — bare side-effect import.
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import template from './TaskExecutionApprovalTable.html?raw';
// NOTE (JS2TS): original define() also listed dead dojo/dijit deps (connect, array, Color, date/locale,
// keys, dijit _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin, registry, dom-style, mouse) — dropped.

class TaskExecutionApprovalTable extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    data: any = null;
    table: any = null;
    layout: any = null;

    _tableFormatter(cell: any): any {
        //console.debug(this.id + "_tableFormatter", cell);

        let rowGroup = cell.tableRow.rowGroup;
        let entity = cell.entity;
        let colname = cell.name;
        let colValue = cell.value;
        let node = cell.tableCellNode;

        switch (colname) {
            case "markings":

                let iconMaterial = this.createFontawesomeIcon("fas fa-boxes tertiaryTXT", "&nbsp;", node);
                let iconFlatrates = this.createFontawesomeIcon("fas fa-money-check-alt tertiaryTXT", "&nbsp;", node);

                if (entity.EL_vt_task_workstep_material_vt_task_executor?.length) {
                    domClass.replace(iconMaterial, "w3-text-teal", "tertiaryTXT");
                    domAttr.set(iconMaterial, "title", "enthält Material");
                }
                if (entity.EL_ht_flat_rate_appointment_vt_appointment?.length) {
                    domClass.replace(iconFlatrates, "w3-text-brown", "tertiaryTXT");
                    domAttr.set(iconFlatrates, "title", "enthält Pauschalen");
                }



                return true;
                break;
            case "actions":

                //let button = domConstruct.create("button", {
                //    className: "mds-button-base mds-hover-dark round"
                //}, node);
                //on(button, "click", lang.hitch(this, this._onClick_Edit, entity));


                //let icon = domConstruct.create("i", {
                //    className: "fas fa-envelope"
                //}, button);

                domConstruct.empty(node);

                return true;
                break;

            case "select":
                if (entity.is_approval_no != true && entity.is_approval_yes != true && !entity.ref_contract_accounting_entity_services) {
                    let checkbox = new CheckBox;

                    checkbox.placeAt(node);
                    checkbox.setValue(false);

                    checkbox.on("change", lang.hitch(this, this._onSelectExecution, entity.ID, checkbox));
                    on(node, "click", function (evt: any) { evt.stopPropagation(); });

                    this._checkboxes.push(checkbox);
                } else {
                    domConstruct.empty(node);

                    if (entity.ref_contract_accounting_entity_services) {
                        let accountedIcon = this.createFontawesomeIcon("fas fa-file-invoice-dollar w3-text-blue", "", node);
                        domAttr.set(accountedIcon, "title", "abgerechnet");
                    }
                    else if (entity.is_approval_yes) {
                        this.createFontawesomeIcon("fas fa-thumbs-up w3-text-green", null, node);
                    } else if (entity.is_approval_no) {
                        this.createFontawesomeIcon("fas fa-thumbs-down w3-text-red", null, node);
                    }
                }
                return true;
                break;

            case "date_start":
                try {
                    if (!colValue || colValue == "") {
                        colValue = entity.CreationDate;
                    }
                    let date = new Date(colValue);
                    let value = "<b>" + this.dateToString(date, "dd.MM.") + "</b>" + this.dateToString(date, "yyyy");

                    domAttr.set(node, "innerHTML", value);
                    return true;
                } catch (ex) {
                    return false;
                }
                break;

            case "taskNo":

                let newStr = "";
                let leadingZeros = true;
                let greySpan = domConstruct.create("span", {
                    className: "w3-opacity"
                }, node);
                for (let i = 0; i < colValue.length; i++) {
                    if (leadingZeros == true && colValue[i] == "0") {
                        //greySpan.innerHTML += colValue[i]; // PLATZ SPAREN
                    } else {
                        leadingZeros = false;
                        newStr += colValue[i];
                    }
                }

                domConstruct.place(greySpan, node, "only");
                node.innerHTML += newStr;

                return true;
                break;
        }


        return false;
    }

    _onClick_Row(row: any): void {
        console.log(this.id + " rowClick", row);
        let entity = row.rowGroup.entity;
        this.emit("click", entity);
    }

    setData(entitylist: any, layout: any): void {
        this.data = entitylist;
        this.layout = layout;

        this.drawTable();
    }

    deselect(): void {
        this._selectedExecutions = [];
        if (this.table) {
            this.table.drawTable();
        }
    }

    selectAll(): void {
        for (let checkbox of this._checkboxes) {
            checkbox.setValue(true);
        }
    }

    _onSelectExecution(entityID: any, checkbox: any, value?: any): void {
        if (!checkbox) return;
        if (!entityID) return;

        //console.debug(this.id + " _onSelectExecution", entityID, value);

        if (this._selectedExecutions == null) this._selectedExecutions = [];

        let index = this._selectedExecutions.indexOf(entityID);
        let state = !!value; // checkbox.getValue();

        if (state === true && index == -1) this._selectedExecutions.push(entityID);
        else if (state === false && index != -1) this._selectedExecutions.splice(index, 1);

        this.emit("selectEntity", this._selectedExecutions);
    }

    _selectedExecutions: any = null;
    _checkboxes: any = null;

    drawTable(): void {
        domClass.add(this.emptyResultsContainer, "w3-hide");
        domClass.add(this.tableContainer, "w3-hide");

        domConstruct.empty(this.tableContainer);
        this._selectedExecutions = [];
        this._checkboxes = [];

        let dateFormat_ddMMyyyy_HHmm = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        let dateFormat_HHmm = { hour: '2-digit', minute: '2-digit' };
        let dateFormat_ddMMyyyy = { year: 'numeric', month: '2-digit', day: '2-digit'/*, hour: '2-digit', minute: '2-digit'*/ };
        let dateFormat_dddd_ddMMyyyy = { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long'/*, hour: '2-digit', minute: '2-digit'*/ };


        if (this.data) {
            if (this.data.length == 0) {
                domClass.remove(this.emptyResultsContainer, "w3-hide");

                return;
            }


            for (let i = 0; i < this.data.length; i++) {
                let entity = this.data[i];

            }

            this.table = new StaticTable();

            this.table.setFormatter(lang.hitch(this, this._tableFormatter));
            this.table.setRowClick(lang.hitch(this, this._onClick_Row));

            this.table.placeAt(this.tableContainer);

            domClass.remove(this.tableContainer, "w3-hide");

            this.table.setLayout(this.layout[0]);
            this.table.setData(this.data);
        }
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }


}
TaskExecutionApprovalTable.prototype.declaredClass = 'WidgetCollection.JDM.TaskApproval.TaskExecutionApprovalTable';

export default mdsWidget(TaskExecutionApprovalTable);
